import { Component } from '@angular/core';
import { CRMIntegrationsService } from '../../../services/crm-integrations.service';
import { ActivatedRoute } from '@angular/router';
@Component({
    selector: 'crm-picker',
    templateUrl: './crm-picker.component.html',
    styleUrl: './crm-picker.component.css',
    standalone: false
})
export class CrmPickerComponent {
  crmList = null;
  isFullPageComponent = false;
  constructor(
    private crmService: CRMIntegrationsService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.crmService.getAvailableCRMs().subscribe(data => {
      if (data) this.crmList = data;
    });
    this.isFullPageComponent = this.route.snapshot.url[0]?.path === 'crm';
  }

  mockList = [
    { name: 'Salesforce', domain: 'https://www.salesforce.com' },
    { name: 'HubSpot', domain: 'https://www.hubspot.com' },
    {
      name: 'Microsoft Dynamics 365',
      domain: 'https://www.microsoft.com/en-gb/dynamics-365',
    },
    { name: 'Zoho CRM', domain: 'https://www.zoho.com/crm/' },
    { name: 'Pipedrive', domain: 'https://www.pipedrive.com' },
  ];
}
